import { render, staticRenderFns } from "./RenderMotoristaUrlImagem.vue?vue&type=template&id=680395e7&scoped=true"
import script from "./RenderMotoristaUrlImagem.vue?vue&type=script&lang=ts"
export * from "./RenderMotoristaUrlImagem.vue?vue&type=script&lang=ts"
import style0 from "./RenderMotoristaUrlImagem.vue?vue&type=style&index=0&id=680395e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680395e7",
  null
  
)

export default component.exports